import { computed, ref } from 'vue';
import { defaultRating, RatingSummary } from '@shared/types/RatingSummary';
import { Review } from '@shared/types/Review';
import { defineStore } from 'pinia';

export const useBaseRatingStore = defineStore('baseRating', () => {
  const rating = ref<RatingSummary>(defaultRating);
  const reviewList = ref<Review[]>([]);
  const reviewsTotal = ref<number>(0);

  const showRating = computed(() => rating.value.ratingCount !== 0 && rating.value.isRateable);

  return { rating, reviewList, showRating, reviewsTotal };
});
